//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import numericsimple from "@/components/numericSimple";
import lazyLoadSelect from "@/components/LazyLoadSelect";
import logger from "@/utils/logger";

export default {
  components: {
    numericsimple,
    lazyLoadSelect
  },
  data() {
    return {
      visibleColumns: [ 
      "productNumber",
      "ProductName",
      "Warehouse",
      "Locations",
      "PriceExVat",
      "QuantityInStock",
      "QuantityAvailable",
      "QuantityIncoming",
      ],
      columns: [
        {
          name: "productNumber",
          align: "left",
          label: "Produkt",
          field: "productNumber",
          sortable: true,
        },
        {
          name: "ProductName",
          align: "left",
          label: this.$t("stock.productName"),
          field: "productName",
          sortable: true,
          headerStyle: "min-width: 120px",
          style:
            "min-width: 120px; max-width:120px; overflow:hidden; white-space:nowrap;",
        },
        {
          name: "Warehouse",
          align: "left",
          label: this.$t("stock.warehouse"),
          field: "warehouseName",
          sortable: true,
        },
        {
          name: "Locations",
          align: "left",
          label: this.$t("stock.location"),
          field: "locations",
          sortable: true,
        },
        {
          name: "PriceExVat",
          align: "right",
          label: this.$t("products.price"), // Sett max desimaler ved visning!
          field: "priceExVat",
          sortable: true,
        },
        {
          name: "QuantityInStock",
          align: "right",
          label: this.$t("products.qty"),
          field: "itemsInStock",
          sortable: true,
        },
        {
          name: "QuantityAvailable",
          align: "right",
          label: this.$t("products.availableQty"),
          field: "itemsAvailable",
          sortable: true,
        },
        {
          name: "QuantityIncoming",
          align: "right",
          label: this.$t("products.incomingQty"),
          field: "itemsIncoming",
          sortable: true,
        },
      ],

      itemColumns: [
        {
          name: "productNumber",
          align: "left",
          label: "Produkt",
          field: "productNumber",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: "Beskrivelse",
          field: "productName",
          sortable: true,
        },
        {
          name: "comment",
          align: "left",
          label: "Info",
          field: "comment",
          sortable: true,
        },
        {
          name: "productUnit",
          align: "left",
          label: "Enhet",
          field: "productUnit",
          sortable: true,
        },
        {
          name: "numberOfItems",
          align: "right",
          label: "Antall",
          field: "numberOfItems",
          sortable: true,
        },
        {
          name: "discount",
          align: "right",
          label: "Rabatt (%)",
          field: "discount",
          sortable: true,
        },
        {
          name: "priceExVat",
          align: "right",
          label: this.$t("products.price"),
          field: "priceExVat",
          sortable: true,
        },
        {
          name: "rowSum",
          align: "right",
          label: this.$t("purchaseOrder.sum"), // Sett max desimaler ved visning!
          field: "rowSum",
          sortable: true,
        },
        {
          name: "warehouseName",
          align: "left",
          label: "Lager",
          field: "warehouseName",
          sortable: true,
        },

        // {
        //   name: "quantity",
        //   align: "right",
        //   label: "På lager",
        //   field: "quantity",
        //   sortable: true,
        // },
      ],

      selectedTab: "searchTab",
      loadComplete: true,
      filter: "",
      articles: [],
      article: [],
      Warehouses: [],
      stocks: [],
      filterStocks: [],
      selectedStocks: [],
      allArticles: [],
      orderItems: [],
      orderStatuses: [41002],
      quoteOrderStatuses: [40102],
      customerStatus: 30001,
      customerId: "",
      departmentId: "",
      projectId: "",
      orderId: "",
      qouteId: "",
      customers: [],
      customersByStatus: [],
      productStatuses: [35001],
      orders: [],
      qoutes: [],
      holder: null,
      holderQoutes: null,
      allOrders: [],
      allQoutes: [],
      // Projects: [],
      // Departments: [],
      createNewOrder: true,
      warehouseId: 0,
      hideTableBottom: true,
      disableSaveOrderBtn: false,
      discounts: [],
      productCategoryLinks: [],
      showM2LmCalculation: false,
      showPkCalculation: false,
      showCalculationHeader: false,
      showCalculationDialog: false,
      showFreeTxtDialog: false,
      height: "",
      width: "",
      unit: "",
      m2Quantity: "",
      mCirumference: "",
      rowComment: "",
      m2Input: "",
      m2PkFactor: "",
      pkQuantity: "",
      rowQuantity: 1,
      orderFreeTxt: "",
      orderSum: 0,
      orderSumIncTax: 0,
      selectedOrderRow: null,
      nextRowId: 1,
      nodatalabel: "Søk etter produkt for å hente data",
      stocksBottommessage: ""
    };
  },
  async created() {
    this.initVisibleColumns();
  },
  async mounted() {
    await Promise.allSettled([
      //(this.customersByStatus = await this.getCustomersByStatus(this.customerStatus)),
      //(this.customers = this.customersByStatus),
      //(this.allOrders = await this.getOrdersByStatuses({orderStatuses: this.orderStatuses})),
      (this.allQoutes = await this.getCustomerQuotes({orderStatuses: this.quoteOrderStatuses})),
      (this.discounts = await this.getProductDiscounts()),
      //(this.articles = await this.getArticles()),
      (this.productCategoryLinks = await this.getProductCategoryLinks()),
      //this.refresh(),      
    ]);



    if (this.customersByStatus) {
      this.customersByStatus.sort((a, b) => a.name.localeCompare(b.name));
    }
    if (this.allOrders) {
      this.allOrders = this.allOrders.filter(x => x.orderItems.filter(y => y.picked == 1).length == 0).sort((a, b) => b.orderNumber - a.orderNumber);
      this.orders = this.allOrders;
      // this.allOrders.sort((a, b) => b.orderDate.localeCompare(a.orderDate));
    }
    if (this.allQoutes) {
      this.allQoutes.sort().reverse();
      this.qoutes = this.allQoutes;     
    }
    if (this.warehouses.length > 1) {
      this.Warehouses.push({ id: "0", warehouseName: "Alle" });
    }
    for (var i = 0; i < this.warehouses.length; i++) {
      this.Warehouses.push(this.warehouses[i]);
    }
    this.warehouseId = this.Warehouses[0].id;
    window.dispatchEvent(new Event("resize"));

    //pluss Ikke lagerførte varer som valg i selecten?

    
  },

  computed: {
    ...mapState("main", ["warehouses", "projects", "departments"]),
  },

  watch: {
    width(newValue, oldValue) {
      if (newValue != oldValue) {
        this.updateCalculationValues();
      }
    },
    height(newValue, oldValue) {
      if (newValue != oldValue) {
        this.updateCalculationValues();
      }
    },
    rowQuantity(newValue, oldValue) {
      if (newValue != oldValue) {
        this.updateCalculationValues();
      }
    },
    m2Input(newValue, oldValue) {
      if (newValue != oldValue) {
        this.updateCalculationValues();
      }
    },
    m2PkFactor(newValue, oldValue) {
      if (newValue != oldValue) {
        this.updateCalculationValues();
      }
    },
  },

  methods: {
    ...mapActions("main", [
      "getArticles",
      "getArticle",
      "getStocksGroupedByWarehouse",
      "getCustomersByStatus",
      "getOrdersByStatuses",
      "getDepartment",
      "getProject",
      "addCustomerOrder",
      "addCustomerOrderItems",
      "addCustomerQuote",
      "getProductDiscounts",
      "getProductCategoryLinks",
      "getCustomerQuotes",
      "addCustomerQuoteItems",
      "getReferencesOrders",
      "getSalesOrder",
      "getReferencesCustomerByStatus"
    ]),

    onVisibleColumnsChange() {
      if (this.isRecevingMode)
        this.$cookies.set(
          "stockOverviewProductRecieveColumns",
          this.visibleColumns.join(","),
          "1Y"
        );
      else
        this.$cookies.set(
          "stockOverviewProcutColumns",
          this.visibleColumns.join(","),
          "1Y"
        );
    },
    initVisibleColumns() {
      var cookieColums = this.$cookies.get("stockOverviewProcutColumns");
      if (this.isRecevingMode)
        cookieColums = this.$cookies.get("stockOverviewProductRecieveColumns");

      if (cookieColums) {
        var columns = [];
        cookieColums.split(",").forEach(function (col) {
          columns.push(col);
        });
        this.visibleColumns = columns;
      }
    },

    async refresh() {
      //this.loadComplete = false;
      this.stocks = [];
      this.selectedStocks = [];
      this.orderItems = [];
      this.filter = "";

      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      this.stocks = await this.getStocksGroupedByWarehouse({includeEmptyLocations: true, statuses: this.productStatuses, filter: this.filter});
      this.filterStocks = this.stocks;

      setTimeout(() => {
        notif();
      }, 2000);
      this.loadComplete = true;
    },
    onEnterSearchOrders() {
      var order = this.allOrders.find((x) => x.orderNumber == this.holder);
      this.orderId = order.id;
      document.activeElement.blur();
    },
    onEnterSearchQoutes() {
      var order = this.allQoutes.find(
        (x) => x.quoteNumber == this.holderQoutes
      );
      this.qouteId = order.id;
      document.activeElement.blur();
    },
    filterCustomers(val, update) {
      if (!this.customersByStatus) {
        update();
        return;
      }
   
      update(() => {
        this.customers = this.customersByStatus.filter(
          (c) =>
            c.name.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
            c.customerNumber
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
        );
      });
    },

    filterOrders(val, update) {
      if (!this.allOrders) {
        update();
        return;
      }
      update(() => {
        this.orders = this.allOrders.filter(
          (c) =>
            c.orderNumber.toString().indexOf(val.toLowerCase()) > -1 ||
            (c.customerName &&
              c.customerName.toLowerCase().indexOf(val.toLowerCase()) > -1)
        );
      });
    },

    filterQoutes(val, update) {
      if (!this.allQoutes) {
        update();
        return;
      }
      update(() => {
        this.qoutes = this.allQoutes.filter(
          (c) =>
            c.quoteNumber.toString().indexOf(val.toLowerCase()) > -1 ||
            (c.customerName &&
              c.customerName.toLowerCase().indexOf(val.toLowerCase()) > -1)
        );
      });
    },

    removeOrderId() {
    
      this.orderId = "";
    },
    removeQoutaId() {
    
      this.qouteId = "";
    },
    removeDepartmentID() {
   
      this.departmentId = "";
    },
    removeProjectId() {
     
      this.projectId = "";
    },
    removeCustomerId() {
  
      this.customerId = "";
    },

    onUnitClick(row) {
      this.unit = row.productUnit;
      this.selectedOrderRow = row;
      this.showM2LmCalculation =
        row.productUnit == "m2" ||
        row.productUnit == "m" ||
        row.productUnit == "meter" ||
        row.productUnit == "lm" ||
        row.productUnit == "lpm";
      this.showPkCalculation =
        row.productUnit.toLowerCase() == "pk" ||
        row.productUnit.toLowerCase() == "pak" ||
        row.productUnit.toLowerCase() == "pakke";
      this.showCalculationHeader =
        this.showM2LmCalculation || this.showPkCalculation;
      if (row.comment) {
        this.rowComment = row.comment;
      }
      if (this.showPkCalculation && row.conversionFactor) {
        this.m2PkFactor = row.conversionFactor;
      }
      this.updateCalculationValues(row.comment == null);
      this.showCalculationDialog = true;
    },

    updateCalculationValues(updateComment = true) {
      if (
        this.showM2LmCalculation &&
        this.width &&
        this.height &&
        this.rowQuantity > 0
      ) {
        this.m2Quantity =
          (this.rowQuantity * this.height * this.width) / 1000000;
        this.mCirumference =
          (this.rowQuantity * (this.height * 2 + this.width * 2)) / 1000;
        if (updateComment) {
          if (this.rowQuantity > 0) {
            this.rowComment =
              this.rowQuantity.toString() +
              "x (" +
              this.width.toString() +
              "x" +
              this.height.toString() +
              ")";
          } else {
            this.rowComment =
              this.width.toString() + "x" + this.height.toString();
          }
        }
      } else if (this.showPkCalculation && this.m2Input && this.m2PkFactor) {
        this.pkQuantity = (1 * this.m2Input) / (1 * this.m2PkFactor);
        if (updateComment) {
          this.rowComment =
            this.m2Input +
            " m2 ≈ " +
            (Math.floor(this.pkQuantity) + 1) +
            " pakker";
        }
      } else {
        this.m2Quantity = "";
        this.mCirumference = "";
        this.pkQuantity = "";
        if (updateComment) {
          this.rowComment = "";
        }
      }
    },

    saveCalculation() {
      if (this.selectedOrderRow) {
        this.updateRow(this.selectedOrderRow);
      }
      this.showCalculationDialog = false;
    },
    saveCalculationRows() {
      if (this.selectedOrderRow) {
        for (var i = 0; i < this.orderItems.length; i++) {
          if (this.orderItems[i].productUnit == this.unit) {
            this.updateRow(this.orderItems[i]);
          }
        }
      }
      this.showCalculationDialog = false;
    },
    updateRow(row) {
      row.comment = this.rowComment;
      var tmp = row.numberOfItems;
      row.numberOfItems = tmp + 1; // for å trigge at rowComment oppdaterer seg hvis kun den er endret.
      row.numberOfItems = tmp;

      if (
        this.unit.toLowerCase() == "pk" ||
        this.unit.toLowerCase() == "pak" ||
        this.unit.toLowerCase() == "pakke"
      ) {
        if (this.pkQuantity) {
          row.conversionFactor = this.m2PkFactor;
          row.numberOfItems = Math.floor(this.pkQuantity) + 1;
        }
      } else if (this.width && this.height && this.rowQuantity > 0) {
        if (this.unit == "m2") {
          row.numberOfItems = Math.round(this.m2Quantity * 100) / 100; // this.m2Quantity.toFixed(2);
        } else if (
          this.unit == "m" ||
          this.unit == "meter" ||
          this.unit == "lm" ||
          this.unit == "lpm"
        ) {
          row.numberOfItems = Math.round(this.mCirumference * 100) / 100;
        }
      }
      this.calculateRow(row);
    },

    async calculateRow(row) {
      if (row) {
        if (row.productId) {
          this.article = await this.getArticle(row.productId);
          
          var price = this.article.priceExVat;

          if (row.numberOfItems < 0.01) {
            row.numberOfItems = 0.01;
           
          }

          var qtySum = row.numberOfItems * price;
       

          const discount = row.discount ? (qtySum * row.discount) / 100 : 0;
          row.rowSum = qtySum - discount;

         
          if (
            this.uni == "m" ||
            this.unit == "m2" ||
            this.unit == "M2" ||
            this.unit == "lpm" ||
            this.unit == "lm"
          ) {
      
            if (!isNaN(this.article.conversionFactor)) {
              
              var unitPrice = qtySum / this.rowQuantity;
       
              if (unitPrice < this.article.conversionFactor) {
                row.priceExVat = this.article.conversionFactor;
                row.numberOfItems = parseInt(this.rowQuantity);
                qtySum = row.numberOfItems * row.priceExVat;
          

                const discount = row.discount
                  ? (qtySum * row.discount) / 100
                  : 0;
                row.rowSum = qtySum - discount;
              } else {
                row.priceExVat = this.article.priceExVat;
              }
            }
          }

          this.updateOrderSum();
        }
      }
    },

    updateOrderSum() {
      this.orderSum = 0;
      for (var i = 0; i < this.orderItems.length; i++) {
        if (this.orderItems[i].rowSum) {
          this.orderSum += parseFloat(this.orderItems[i].rowSum);
        }
      }
      this.orderSumIncTax = this.orderSum * 1.25;
      var roundedString = this.orderSumIncTax.toFixed(2);
      this.orderSumIncTax = new Intl.NumberFormat("no-NO").format(
        Number(roundedString)
      );
      this.orderSum = new Intl.NumberFormat("no-NO").format(this.orderSum);

    },

    copyRow(row) {
      var newItem = {};
      newItem.productId = row.productId;
      newItem.productNumber = row.productNumber;
      newItem.productName = row.productName;
      newItem.warehouseName = row.warehouseName;
      newItem.quantity = this.getQuantity(row.productId);
      newItem.id = "n" + this.nextRowId++;
      newItem.itemsAvailable = row.itemsAvailable;
      newItem.productUnit = row.productUnit;
      newItem.conversionFactor = row.conversionFactor;
      newItem.comment = row.comment;
      newItem.numberOfItems = row.numberOfItems;
      newItem.priceExVat = row.priceExVat;
      newItem.discount = row.discount;
      newItem.rowSum = row.rowSum;
      this.orderItems.push(newItem);
      this.updateOrderSum();
    },
    resetCalculationInputFields() {
      this.width = "";
      this.height = "";
      this.rowQuantity = 1;
      this.rowComment = "";
      this.m2Input = "";
      this.m2PkFactor = "";
    },
    showOrderFreeTxtDlg() {
      this.showFreeTxtDialog = true;
    },

    moveToOrder() {
      var nextNegativeId = -1;
      for (var i = 0; i < this.selectedStocks.length; i++) {
        var item = this.selectedStocks[i];
  

        var selectedItem = {};
        selectedItem.productId = item.productId;
        selectedItem.productNumber = item.productNumber;
        selectedItem.productName = item.productName;
        selectedItem.warehouseName = item.warehouseName;
        selectedItem.numberOfItems = 1;
        selectedItem.quantity = this.getQuantity(item.productId);
        selectedItem.id = item.id;
        selectedItem.itemsAvailable = item.itemsAvailable;
        selectedItem.productUnit = item.productUnit;
        selectedItem.conversionFactor = item.conversionFactor;
        selectedItem.priceExVat = item.priceExVat;
        selectedItem.rowSum = selectedItem.priceExVat;

        if (
          (!selectedItem.itemsAvailable ||
            selectedItem.itemsAvailable == 0 ||
            selectedItem.itemsAvailable < 0) &&
          item.alternativeProductId
        ) {
          var alternativeProduct = this.stocks.find(
            (x) =>
              x.productId === item.alternativeProductId &&
              x.warehouseName == item.warehouseName
          );
          if (
            alternativeProduct &&
            alternativeProduct.itemsAvailable &&
            alternativeProduct.itemsAvailable > 0
          ) {
            selectedItem.productId = alternativeProduct.productId;
            selectedItem.productNumber = alternativeProduct.productNumber;
            selectedItem.productName = alternativeProduct.productName;
            selectedItem.id = nextNegativeId;
            selectedItem.quantity = alternativeProduct.itemsInStock;
            nextNegativeId--;

            this.$q.notify({
              type: "warning",
              message: `Produkt "${item.productNumber}" er ikke tilgjengelig, og ble erstattet av "${selectedItem.productNumber}"`,
            });
          }
        }
       
        if (
          this.orderItems.filter(
            (x) =>
              x.productId == selectedItem.productId &&
              x.warehouseName == selectedItem.warehouseName
          ).length == 0
        ) {
          this.orderItems.push(selectedItem);
        } else {
          this.$q.notify({
            type: "warning",
            message: `Produkt "${selectedItem.productNumber}" er allerede lagt til"`,
          });
        }
      }
      this.selectedStocks = [];
      this.updateDiscount();
      this.updateOrderSum();
    },

    async updateDiscount() {
      if (this.customerId <= 0) return;

      var updatedOrderItems = [];

      this.orderItems.forEach((item) => {
        var categoryLinksIds = this.productCategoryLinks
          .filter((x) => x.productID === item.productId)
          .map((x) => x.productCategoryID);
        if (categoryLinksIds) {
          var productDiscount = this.discounts.find(
            (x) =>
              x.customerId === this.customerId &&
              categoryLinksIds.includes(x.productCategoryId)
          );
          if (productDiscount && productDiscount.discount > 0) {
            item.discount = productDiscount.discount;
            item.rowSum = item.rowSum - 1 * item.discount;
          }
        }
        updatedOrderItems.push(item);
      });
      this.orderItems = updatedOrderItems;
    },

    getQuantity(productId) {
      var q = 0;
      var productLines = this.stocks.filter((x) => x.productId == productId);

      for (var i = 0; i < productLines.length; i++) {
        q += productLines[i].itemsInStock;
      }

      if (isNaN(q)) return "";
      return parseInt(q.toString());
    },

    deleteLine(index) {
      this.orderItems.splice(index, 1);
      this.updateOrderSum();
    },

    clearOrder() {
      this.orderItems = [];
      this.customerId = "";
      this.departmentId = "";
      this.projectId = "";
      this.orderId = "";
      this.qouteId = "";
      this.width = "";
      this.height = "";
      this.m2Input = "";
      this.m2PkFactor = "";
      this.unit = "";
      this.rowComment = "";
      this.rowQuantity = 1;
      this.orderFreeTxt = "";
      this.updateOrderSum();
    },

    async saveOrder() {
      this.disableSaveOrderBtn = true;
      var order = {};
      var items = [];
      this.orderItems.forEach(function(item) {
        var newItem = {};
        newItem.productId = item.productId;
        newItem.numberOfItems = item.numberOfItems;
        newItem.discount = item.discount;
        newItem.warehouseName = item.warehouseName;
        newItem.priceExVat = item.priceExVat;
        newItem.itemText = item.productName;
        newItem.Comment = item.comment ? " " + item.comment : "";

        items.push(newItem);
      });
      order.items = items;
   
      try {
        const notif = this.$q.notify({
          type: "ongoing",
          message: "Lagrer...",
        });
        setTimeout(() => {
          notif();
        }, 500);
        if (this.createNewOrder) {
          order.customerId = this.customerId;
          if (this.departmentId > 0) {
            order.departmentId = this.departmentId;
          }
          if (this.projectId > 0) {
            order.projectId = this.projectId;
          }
          order.comment = "";
          order.FreeTxt = this.orderFreeTxt;
       
          await this.addCustomerOrder(order);
          //this.allOrders = await this.getOrdersByStatuses({orderStatuses: this.orderStatuses});
        } else {
          if (this.orderId == "") {
            order.id = this.qouteId;
            await this.addCustomerQuoteItems(order);
          } else {
            order.id = this.orderId;
            await this.addCustomerOrderItems(order);
          }
        }

        this.clearOrder();
        this.filter = "";
        this.selectedTab = "searchTab";

        this.$q.notify({
          type: "positive",
          message: this.$t("common.saveOk"),
        });
      } catch (error) {
        this.disableSaveOrderBtn = false;
        logger.log("error", error);
        this.$q.notify({
          type: "negative",
          message: `${this.$t(
            "common.errorSave"
          )}. ${this.$utils.GetErrorMessage(error)}`,
        });
      }
      this.disableSaveOrderBtn = false;
    },

    async saveQuote() {
      var quote = {};
      var items = [];
      this.orderItems.forEach(function(item) {
        var newItem = {};
        newItem.productId = item.productId;
        newItem.numberOfItems = item.numberOfItems;
        newItem.discount = item.discount; // ??
        newItem.warehouseName = item.warehouseName; // ??
        newItem.priceExVat = item.priceExVat;
        newItem.itemText = item.productName;
        newItem.Comment = item.comment ? " " + item.comment : "";

        items.push(newItem);
      });
      quote.items = items;

      try {
        quote.id = this.customerId;
        if (this.departmentId > 0) {
          quote.departmentId = this.departmentId;
        }
        if (this.projectId > 0) {
          quote.projectId = this.projectId;
        }
        quote.FreeTxt = this.orderFreeTxt;
        await this.addCustomerQuote(quote);

        this.clearOrder();
        this.filter = "";
        this.selectedTab = "searchTab";

        this.$q.notify({
          type: "positive",
          message: this.$t("common.saveOk"),
        });
      } catch (error) {
        logger.log("error", error);
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave"),
        });
      }
    },

    onRequest(params) {
      logger.log(params);
    },

    async searchStocks(){
      logger.log(this.filter);
      this.stocksBottommessage = "";

      if(this.filter == undefined || this.filter == ''){
        this.stocks = [];
        this.filterStocks = this.stocks;
        this.nodatalabel = "Søk etter produkt for å hente data"
        this.loadComplete = true;
        return;
      }

      if(this.filter.length < 3){
        this.stocks = [];
        this.filterStocks = this.stocks;
        this.nodatalabel = "Søket må bestå av minst 3 tegn"
        this.loadComplete = true;
        return;
      }


      this.loadComplete = false;

      var data = await this.getStocksGroupedByWarehouse({includeEmptyLocations: false, statuses: this.productStatuses, filter: this.filter});

      logger.log("treff:")
logger.log(data.length);

      if(data.length >= 50){
        this.stocks = data.slice(0, 30);
        this.filterStocks = this.stocks;
        this.stocksBottommessage = "For mange treff, viser kun de 30 første treff";        
        this.loadComplete = true;
        return;
      }

      this.stocks = data;


      this.filterStocks = this.stocks;

      if(this.stocks.length == 0){
        this.nodatalabel = "Ingen treff"
      }


      this.loadComplete = true;
    },

    async fetchOrders({ pageNumber, pageSize, searchQuery }) {
            try {
                const result = await this.getReferencesOrders({
                    pageNumber,
                    pageSize,
                    searchQuery,
                    sortBy: 'OrderNumber',
                    sortDescending: true, // denne var orginalt koda false ? 
                    excludeLockedOrders: true
                })
                return result
            } catch (error) {
                console.error('Error fetching order:', error)
                return { items: [], totalPages: 1 }
            }
        },

      async fetchorder(orderId) {
          try {
              const result = await this.getSalesOrder(orderId)
              logger.log({result})
              return result
          } catch (error) {
              console.error('Error fetching order:', error)
              return null;
          }
      },

      orderLabel(order) {
          if (!order) return ''
          return `${order.orderNumber} ${order.customerName}`
      },

      async searchOrder() {
      logger.log("searchOrder: "+ this.orderNo)    
    },

    async fetchCustomers({ pageNumber, pageSize, searchQuery }) {
            try {
                const result = await this.getReferencesCustomerByStatus({
                    pageNumber,
                    pageSize,
                    searchQuery,
                    sortBy: 'CustomerNumber',
                    sortDescending: false,
                    statusCode: 30001
                })
                return result
            } catch (error) {
                console.error('Error fetching customer:', error)
                return { items: [], totalPages: 1 }
            }
        },

      async fetchCustomer(customerId) {
          try {
              const result = await this.getSalesOrder(customerId)
              logger.log({result})
              return result
          } catch (error) {
              console.error('Error fetching customer:', error)
              return null;
          }
      },

      customerLabel(customer) {
          if (!customer) return ''
          return `${customer.customerNumber} ${customer.name}`
      },

      async searchCustomer() {
      logger.log("searchCustomer: "+ this.customerId)    
    },

    async getWarehouseStocks() {
      if (this.warehouseId < 1) this.stocks = this.filterStocks;
      else
        this.stocks = this.filterStocks.filter((x) => x.warehouseId == this.warehouseId);

        if(this.stocks.length == 0){
        this.nodatalabel = "Ingen treff"
      }
    },
  },
};
